import { cloneDeep } from 'lodash';
import getStateDefault from './state';

export const types = {
    ADD_ITEM: 'ADD_ITEM',
    SET_ITEMS: 'SET_ITEMS',
    SET_ITEM_QTY: 'SET_ITEM_QTY',
    SET_TOTAL_PRICE: 'SET_TOTAL_PRICE',
    SET_IS_POSSIBLE_CHECKOUT: 'SET_IS_POSSIBLE_CHECKOUT',
    SET_DELIVERY_INFO: 'SET_DELIVERY_INFO',
    SET_ITEMS_COUNT: 'SET_ITEMS_COUNT',
    SET_NEED_FETCH: 'SET_NEED_FETCH',
    FLUSH_CART: 'FLUSH_CART',
    DELETE_ITEM: 'DELETE_ITEM',
    SET_MULTISOURCE: 'SET_MULTISOURCE',
};

function mutateItemQty(items, id, qty) {
    let isQtyChanged = false;
    items.some((item) => {
        if (item.itemId === id) {
            item.quantity = qty;
            isQtyChanged = true;
            return true;
        } if (item.items && item.items.length) {
            const { isQtyChanged: qtyChanged } = mutateItemQty(item.items, id, qty);

            return qtyChanged;
        }
        return false;
    });

    return { items, isQtyChanged };
}

function deleteItemById(items, id) {
    let isItemDeleted = false;
    items.some((item, index) => {
        if (item.itemId === id) {
            isItemDeleted = true;
            items.splice(index, 1);
            return true;
        } if (item.items && item.items.length) {
            const { isItemDeleted: itemDeleted } = deleteItemById(item.items, id);

            return itemDeleted;
        }
        return false;
    });

    return { items, isItemDeleted };
}

const mutations = {
    [types.ADD_ITEM](state, item) {
        state.items.push(item);
    },
    [types.SET_ITEMS](state, cart) {
        state.items = cart;
    },
    [types.SET_TOTAL_PRICE](state, cartSubtotal) {
        state.totalPrice = cartSubtotal;
    },
    [types.SET_IS_POSSIBLE_CHECKOUT](state, isPossibleCheckout) {
        state.isPossibleCheckout = isPossibleCheckout;
    },
    [types.SET_DELIVERY_INFO](state, deliveryInfo) {
        state.deliveryInfo = deliveryInfo;
    },
    [types.SET_ITEMS_COUNT](state, count) {
        state.itemsCount = count;
    },
    [types.SET_NEED_FETCH](state, needFetch) {
        state.needFetch = needFetch;
    },
    [types.FLUSH_CART](state) {
        Object.assign(state, getStateDefault());
    },
    [types.SET_ITEM_QTY](state, { id, qty }) {
        state.items = mutateItemQty(cloneDeep(state.items), id, qty).items;
    },
    [types.DELETE_ITEM](state, { id }) {
        state.items = deleteItemById(cloneDeep(state.items), id).items;
    },
    [types.SET_MULTISOURCE](state, isMultisource) {
        state.isMultisource = isMultisource;
    },
};

export default mutations;
